"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Rail = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("./styles");

var _RailContainer = require("./RailContainer");

var _Tile = require("./Tile");

var _Integration = require("./Integration");

var _ExpandedRail = require("./ExpandedRail");

var _Tiles = _interopRequireDefault(require("./Tiles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const noop = () => null;

const Rail = /*#__PURE__*/_react.default.memo(({
  containerProps,
  features,
  expandedSearchInputProps,
  integrationSearchInputProps,
  integrationSearchResultsView,
  expandedSearchResultsView,
  suggestions,
  onSelectFeature,
  onRemoveFeature,
  showCustomization,
  onDragEnd,
  onClickAddSuggestion
}) => {
  const [showIntegrationIcon, setShowIntegrationIcon] = (0, _react.useState)(!showCustomization);
  const [showExpandedRail, setShowExpandedRail] = (0, _react.useState)(false);
  const [showIntegration, setShowIntegration] = (0, _react.useState)(false);
  const [selectedFeature, setSelectedFeature] = (0, _react.useState)({});

  const onSetSelectedFeature = ({
    iconName,
    label,
    id,
    ...rest
  }) => {
    if (iconName && label) {
      setShowExpandedRail(true);
      setSelectedFeature({
        iconName,
        label,
        id
      });
      onSelectFeature({
        iconName,
        label,
        id,
        ...rest
      });
    }
  };

  (0, _react.useEffect)(() => {
    setShowIntegrationIcon(!showCustomization);
  }, [showCustomization]);
  return /*#__PURE__*/_react.default.createElement(_RailContainer.RailContainer, containerProps, /*#__PURE__*/_react.default.createElement(_styles.RailItemsStyle, null, /*#__PURE__*/_react.default.createElement(_Tiles.default, {
    features: features,
    onSelectFeature: onSetSelectedFeature,
    onRemoveFeature: onRemoveFeature,
    showCustomization: showIntegrationIcon,
    onDragEnd: onDragEnd,
    "data-testid": "features"
  })), /*#__PURE__*/_react.default.createElement(_styles.RailItemsStyle, {
    jc: "center"
  }, showIntegrationIcon && /*#__PURE__*/_react.default.createElement(_Tile.IconTile, {
    label: `ADD Integrations`,
    iconName: "Add",
    fill: "#121213",
    size: 21,
    onClick: setShowIntegration,
    capitalize: true,
    className: "flot-tile"
  }), !showIntegrationIcon && /*#__PURE__*/_react.default.createElement(_Tile.IconTile, {
    label: `Customize`,
    iconName: "Customize",
    size: 48,
    onClick: setShowIntegrationIcon,
    className: "flot-tile"
  })), showIntegration && /*#__PURE__*/_react.default.createElement(_Integration.Integration, _extends({}, containerProps, {
    onClickBack: () => setShowIntegration(false),
    suggestions: suggestions,
    inputProps: integrationSearchInputProps,
    integrationSearchResultsView: integrationSearchResultsView,
    onClickAddSuggestion: onClickAddSuggestion
  })), showExpandedRail && /*#__PURE__*/_react.default.createElement(_ExpandedRail.ExpandedRail, _extends({}, containerProps, selectedFeature, {
    onClose: () => setShowExpandedRail(false),
    inputProps: expandedSearchInputProps,
    expandedSearchResultsView: expandedSearchResultsView
  })));
});

exports.Rail = Rail;
Rail.defaultProps = {
  showCustomization: true,
  containerProps: {
    position: 'right'
  },
  integrationSearchInputProps: {
    boxed: false,
    placeholder: 'Search'
  },
  expandedSearchInputProps: {
    boxed: false,
    placeholder: 'Search'
  },
  features: [],
  suggestions: [],
  onDragEnd: noop,
  onClickAddSuggestion: noop,
  onSelectFeature: noop,
  onRemoveFeature: noop
};
Rail.propTypes = {
  /** Rail container css props*/
  containerProps: _propTypes.default.object,

  /** Rail features list in array of {iconName, label, id} */
  features: _propTypes.default.array,

  /** Search input component props*/
  integrationSearchInputProps: _propTypes.default.object,

  /** Search input component props*/
  expandedSearchInputProps: _propTypes.default.object,

  /** A custom view for expanded search Rail Component*/
  integrationSearchResultsView: _propTypes.default.node,

  /** A custom view for search Integration Rail Component*/
  expandedSearchResultsView: _propTypes.default.node,

  /** Integration suggestions list in array of */
  suggestions: _propTypes.default.arrayOf(_propTypes.default.shape({
    isSelected: _propTypes.default.bool.isRequired,
    iconName: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired
  })),

  /** A Callback function for onSelect feature on Rail, and it return object*/
  onSelectFeature: _propTypes.default.func.isRequired,

  /** A Callback function for Remove a feature on Rail and it return object*/
  onRemoveFeature: _propTypes.default.func.isRequired,

  /** A Callback function for onDragEnd, and it will return sorted array of features*/
  onDragEnd: _propTypes.default.func.isRequired,

  /** To enable customize icon*/
  showCustomization: _propTypes.default.bool,

  /** A Callback function for add suggestions, and it return object */
  onClickAddSuggestion: _propTypes.default.func.isRequired
};